
namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class NewsletterStoryGrid extends Serenity.EntityGrid<NewsletterStoryRow, any> {
        protected getColumnsKey() { return NewsletterStoryColumns.columnsKey; }
        protected getDialogType() { return NewsletterStoryDialog; }
        protected getIdProperty() { return NewsletterStoryRow.idProperty; }
        protected getInsertPermission() { return NewsletterStoryRow.insertPermission; }
        protected getLocalTextPrefix() { return NewsletterStoryRow.localTextPrefix; }
        protected getService() { return NewsletterStoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }


        protected usePager() {
            return false;
        }
        private _newsletterID: number;

        get newsletterID() { 
            return this._newsletterID;
        }

        set newsletterID(value: number) {
            if (this._newsletterID !== value) {
                this._newsletterID = value;
                this.setEquality('NewsletterID', value);
                this.refresh();
            }
        }
    }
}